module.exports = "<notice-list></notice-list>";


//////////////////
// WEBPACK FOOTER
// ./src/component/systemNotice/noticeIndex.html
// module id = 207
// module chunks = 0